import { applyMiddleware, createStore } from "redux"

//import logger from "redux-logger"
import thunk from "redux-thunk"
import promise from "redux-promise-middleware"
import {history} from "./helpers/history"
import {
  routerMiddleware
} from "react-router-redux"

import reducer from "./reducers"

const middleware = applyMiddleware(promise(), thunk, routerMiddleware(history)) // debug middleware: logger()

export default createStore(reducer, middleware)



// WEBPACK FOOTER //
// ./src/js/store.js